import * as React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Stepper({
  onChange = () => {}
}) {
  const [step, setStep] = React.useState(0);
  const params = useParams();

  // show the term sheet's FILE NAME, not its internal UUID
  const [tsName, setTsName] = React.useState(null);
  React.useEffect(() => {
    if (!params.termSheetId) { setTsName(null); return; }
    let alive = true;
    axios.get(`${API}/termsheet/${params.termSheetId}`)
      .then((r) => { if (alive) setTsName(r.data?.term_sheet?.filename || null); })
      .catch(() => { if (alive) setTsName(null); });
    return () => { alive = false; };
  }, [params.termSheetId]);

  const steps = [
    { title: "Upload Term Sheets", subTitle: "PDF or Excel", description: "Upload multiple term sheets" },
    { title: "Review Data", subTitle: "AI-Extracted", description: tsName },
    { title: "Add Weather Data", subTitle: "Daily Records" },
    { title: "Burning Cost", subTitle: "Historical Loss Experience", description: tsName },
    { title: "Loadings & Final Rates", subTitle: "Rates + Payout Analysis", description: tsName },
  ];
  const current = steps[step];

  React.useEffect(() => {
    const url = window.location.href || "";
    if (params.termSheetId) {
      if (url.includes("/weather")) {
        setStep(2);
      } else if (url.includes("/burning-cost")) {
        setStep(3);
      } else if (url.includes("/results")) {
        setStep(4);
      } else {
        setStep(1);
      }
    } else if (url.includes('/weather-view')) {
      setStep(-1);
    } else {
      setStep(0);
    }
  }, [params]);

  const stepClickHandler = (status, stepInd) => {
    if(status == 'completed') {
      setStep(stepInd);
      onChange(stepInd);
    }
  };

  return (
    step >= 0 ?
    <div className="max-w-6xl mx-auto flex items-center justify-between pt-8 gap-y-4 flex-wrap md:flex-nowrap px-4 lg:px-0">
      <div className="flex items-center gap-4">
        <div>
          <h1 className="font-heading font-bold text-xl text-foreground">
            {current.title} - <span className="text-muted-foreground text-sm">{current.subTitle}</span>
          </h1>
          <p className="text-muted-foreground text-sm pt-1">
            Step {step + 1} of {steps.length}
            {current.description ? ` · ${current.description}` : ""}
          </p>
        </div>
      </div>

      {/* Stepper */}
      <div className="flex items-center gap-3 md:gap-2">
        {steps.map((stepInfo, i) => {
          let clsName = "pending";

          if (i < step) {
            clsName = "completed";
          } else if (i === step) {
            clsName = "active";
          }

          return (
            <React.Fragment key={stepInfo.title}>
              <div className={`stepper-circle ${clsName}`} onClick={() => stepClickHandler(clsName, i)}
                title={stepInfo.title}>
                {i + 1}
              </div>
              {i < steps.length - 1 && <div className="stepper-line w-8"></div>}
            </React.Fragment>
          )
        })}
      </div>
    </div> : null
  );
}
